import type { Action } from 'redux';
import type { Redirect } from '../../../../main/screens/ScreenLinkHubAdLinkCreator/steps/RedirectsStep/Redirects.types';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateAndroidRedirect = new ReduxAsyncAction<'UPDATE_ANDROID_REDIRECT', Redirect, { androidRedirect: Redirect }>(
  'UPDATE_ANDROID_REDIRECT'
);

UpdateAndroidRedirect.registerRequest(async (androidRedirect: Redirect) => {
  return { androidRedirect };
});

export const UPDATE_ANDROID_REDIRECT = UpdateAndroidRedirect.actionNamespaceConstants;
export const updateAndroidRedirect = UpdateAndroidRedirect.request;

export type UpdateAndroidRedirectResponseAction = Action<typeof UPDATE_ANDROID_REDIRECT.response> & {
  data: { androidRedirect: Redirect };
};
